import React, { useEffect } from "react";
import GKLogo from "../images/good-karma-logo.png";

const GoodKarmaCafe = () => {
  useEffect(() => {
    document.title = "Auburn Road - Good Karma";
    return () => {
      document.title = "Auburn Road Vineyards";
    };
  }, []);
  return (
    <div className="container inner-container p-t-200">
      <h2 className="huge-text-no-quote">
        Good Karma <span className="accent-text">Cafe</span>
      </h2>
      <p className="mt-5">
        Auburn Road Vineyards would like to welcome you to Good Karma Cafe and
        Wine Bar Philly! Good Karma Café is a café and wine bar in the European
        style. Join us for world-class wine, locally made beer and spirits,
        amazing food and delicious organic and fair trade coffee!
      </p>
      <iframe
        width="350px"
        height="615"
        src="https://www.youtube.com/embed/JyPwmjRQ2b4?si=iTW0JXe9hSOhGF8P"
        frameborder="0"
        allowfullscreen
        title="cowtown video"
      ></iframe>
      <p className="m-t-30">
        <a
          href="https://www.thegoodkarmacafe.com"
          target="_blank"
          rel="noreferrer"
        >
          Good Karma Cafe & Wine Bar Society Hill 928 pine street Philly
        </a>
      </p>
      <img src={GKLogo} alt="good karma logo" />
    </div>
  );
};
export default GoodKarmaCafe;
